import React, {Component} from "react";
import {getHours, getAMorPM, getMonth, sortScanDates} from "../../shared/dateFormatter";
import ContentPanel from "../ContentPanel/ContentPanel";
import {requestScanDetailsData} from "../../actions/scanDetailsDataActions";
import {requestShipmentDetailsData} from "../../actions/shipmentDetailsDataActions";
import connect from "react-redux/es/connect/connect";
import withRouter from "react-router/es/withRouter";
import Skeleton from "../Skeleton/Skeleton";
import queryString from "query-string";
import {REQUEST_FACILITIES_DATA} from "../../actions/facilitiesActions";
import {getDescriptionForAWBStatus, getCSSForAWBStatus} from '../../shared/awbStatus';

class ScanDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            shipmentDetails: {}
        }
    }

    componentDidMount() {
        const querystringParams = queryString.parse(this.props.location.search);
        const trackingIdParam = querystringParams.trackingId;
        if (trackingIdParam !== undefined) {
            const index = trackingIdParam.indexOf('-');
            const trackingInfoToSend = {
                awbPrefix: trackingIdParam.substr(0, index),
                airWaybillNumber: trackingIdParam.substr(index + 1, trackingIdParam.length),
                isoCreateDate: querystringParams.createDate,
            };
            this.props.getScanDetails(trackingInfoToSend);
            const trackingInfoToSend2 = [{
                airlineCode: trackingIdParam.substr(0, index),
                trackingNumber: trackingIdParam.substr(index + 1, trackingIdParam.length)
            }];
            this.props.requestShipmentDetailsData(trackingInfoToSend2);
            if (!this.props.rawFacilities) {
                this.props.getRawFacilities();
            }
        }
    }

    buildViewModel = () => {
        if (Object.keys(this.props.shipmentDetailsData).length === 0) {
            return;
        }
        const shipmentDetails = {
            trackingId: this.props.shipmentDetailsData.awbPrefix + ' ' + this.props.shipmentDetailsData.awbNumber,
            awbStatus: this.props.shipmentDetailsData.awbStatus,
            serviceLevel: this.props.shipmentDetailsData.serviceLevel ? this.props.shipmentDetailsData.serviceLevel.description : null,
            destinationCode: this.props.shipmentDetailsData.destination ? this.props.shipmentDetailsData.destination.code : null,
            originCode: this.props.shipmentDetailsData.origin ? this.props.shipmentDetailsData.origin.code : null,
            shipperName: this.props.shipmentDetailsData.shipperName,
            shipperAddressLine1: this.props.shipmentDetailsData.shipperAddress ? this.props.shipmentDetailsData.shipperAddress.addressLine : null,
            shipperAddressLine2: this.props.shipmentDetailsData.shipperAddress ? this.props.shipmentDetailsData.shipperAddress.addressLine2 : null,
            shipperAddressCityState: this.props.shipmentDetailsData.shipperAddress ? this.props.shipmentDetailsData.shipperAddress.city : null,
            consigneeName: this.props.shipmentDetailsData.consigneeName,
            consigneeAddressLine1: this.props.shipmentDetailsData.consigneeAddress ? this.props.shipmentDetailsData.consigneeAddress.addressLine : null,
            consigneeAddressLine2: this.props.shipmentDetailsData.consigneeAddress ? this.props.shipmentDetailsData.consigneeAddress.addressLine2 : null,
            consigneeAddressCityState: this.props.shipmentDetailsData.consigneeAddress ? this.props.shipmentDetailsData.consigneeAddress.city : null
        };
        this.setState({
            shipmentDetails: shipmentDetails,
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.shipmentDetailsData.awbNumber !== this.props.shipmentDetailsData.awbNumber ||
                Object.keys(this.state.shipmentDetails).length === 0) {
            this.buildViewModel();
        }
    }

    render() {
        let retVal;
        let originLocationCityState;
        let originLocation;
        let destinationLocation;
        let destinationLocationCityState;

        if (this.props.rawFacilities) {

            destinationLocation = this.props.rawFacilities ? this.props.rawFacilities.filter((item) => {
                return item.airportCodeIATA === this.state.shipmentDetails.destinationCode
            })[0] : null;

            if (!destinationLocation) {
                destinationLocationCityState = "";
            } else {
                destinationLocationCityState = destinationLocation.airportCodeIATA + " - " + destinationLocation.commonAirportName;
            }

            originLocation = this.props.rawFacilities ? this.props.rawFacilities.filter((item) => {
                return item.airportCodeIATA === this.state.shipmentDetails.originCode
            })[0] : null;

            if (!originLocation) {
                originLocationCityState = "";
            } else {
                originLocationCityState = originLocation.airportCodeIATA + " - " + originLocation.commonAirportName;
            }
        }

        if (this.props.scanDetailsData.isFetching) {
            retVal = <div className="piece-detail">Loading...</div>;
        } else if (this.props.scanDetailsData.noResults || this.props.scanDetailsData.error || this.props.scanDetailsData.scanDetails.length === 0) {
            retVal = <ContentPanel
                    skeleton={<Skeleton type="MAIN_PANEL"/>}
                    errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
                    templateUrl={"./content/ship/page-components/text-block/scans-unavailable.html"}
            />;
        } else {
            sortScanDates(this.props.scanDetailsData.scanDetails);
            retVal = <div className="tracking-details-wrapper">
                <div className="tracking-details-tracking-inner-container">
                    <div className="tracking-details-tracking__header">
                        <span className="tracking-details-header-tracking__label"> Tracking Detail: </span>
                        {this.state.shipmentDetails.trackingId}
                    </div>
                    <div className="tracking-details-button__header">
                        <button type="submit" className="print-transparent" onClick={() => window.print()}>
                            <span className="tracking-details-medium-to-small-header-panel-button__text"> Print </span>
                        </button>
                    </div>
                </div>

                <div className="tracking-details-medium-to-small-header-wrapper">
                    <div className="tracking-details-header-tracking__label">Tracking Detail</div>
                    <p className="tracking-details-header-air-waybill__label text-uppercase mtm">Air Waybill</p>
                    <p className="tracking-details-header-air-waybill mtm"> {this.state.shipmentDetails.trackingId} </p>
                </div>
                <div className="tracking-details-medium-to-small-header-panel-button">
                    <button type="submit" className="print-transparent" onClick={() => window.print()}>
                        <span className="tracking-details-medium-to-small-header-panel-button__text"> Print </span>
                    </button>
                </div>

                <div className={getCSSForAWBStatus(this.state.shipmentDetails.awbStatus)}>
                    <div className="tracking-details-status-destination_inline">
                        <div className="tracking-details-status-and-service__label text-uppercase">AIR WAYBILL STATUS</div>
                        <div className="tracking-details-status-and-service__text"> {getDescriptionForAWBStatus(this.state.shipmentDetails.awbStatus)}</div>
                    </div>
                    <div className="tracking-details-status__spacer"/>
                    <div className="tracking-details-status-destination_inline">
                        <div className="tracking-details-status-and-service__label text-uppercase tracking-details-destination_label">Origin</div>
                        <div className="tracking-details-status__city"> {originLocationCityState}</div>
                    </div>
                    <div className="tracking-details-status__spacer"/>
                    <div className="tracking-details-status-destination_inline">
                        <div className="tracking-details-status-and-service__label text-uppercase tracking-details-destination_label">Destination</div>
                        <div className="tracking-details-status__city"> {destinationLocationCityState}</div>
                    </div>
                </div>

                <div
                        className="tracking-details-status-and-service__wrapper tracking-details-status-and-service-background__blue">
                    <div className="tracking-details-status-and-service__label text-uppercase"> SERVICE Level</div>
                    <div
                            className="tracking-details-status-and-service__text text-uppercase"> {this.state.shipmentDetails.serviceLevel} </div>
                </div>
                <div className="tracking-details-inner-container" style={{border: 'solid 1px #e6e7e8', padding: '1em'}}>
                    <div className="piece-popper__table whiteTable">
                        <div className="divTableHeading">
                            <div className="divTableRow">
                                <div className="divTableHead">Time</div>
                                <div className="divTableHead">Status</div>
                                <div className="divTableHead">Station</div>
                                <div className="divTableHead">Flight</div>
                                <div className="divTableHead">Pieces</div>
                            </div>
                        </div>
                        <div className="divTableBody">
                            {
                                this.props.scanDetailsData.scanDetails ? (
                                        this.props.scanDetailsData.scanDetails.map(item => {
                                                    return (
                                                            <div className="divTableRow">
                                                                <div className="divTableCell">{getMonth(item.scanTime) + " " + getHours(item.scanTime) + " " + getAMorPM(item.scanTime)}</div>
                                                                <div className="divTableCell">{item.scanType}</div>
                                                                <div className="divTableCell">{item.scanStation}</div>
                                                                <div className="divTableCell">{item.flightNumber}</div>
                                                                <div className="divTableCell">{item.scanCount}</div>
                                                            </div>
                                                    )
                                                }
                                        )) : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        }
        return retVal;
    }
}

const mapStateToProps = (state) => {
    return {
        scanDetailsData: state.scanDetailsData,
        shipmentDetailsData: state.shipmentDetails.item,
        rawFacilities: state.facilitiesData.rawFacilities
    }
};

const mapDispatchToProps = dispatch => ({
    getScanDetails: (request) => dispatch(requestScanDetailsData(request)),
    requestShipmentDetailsData: data => {
        dispatch(requestShipmentDetailsData(data));
    },
    getRawFacilities: () => dispatch({type: REQUEST_FACILITIES_DATA})
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ScanDetails));



// WEBPACK FOOTER //
// ./src/components/ScanDetails/ScanDetails.js